import {REST_DOCUMENT_CHECK_TYPE_URL} from "../common/constants";
import ExpandableList from "../common/ExpandableList";
import DocumentCheckType, {DocumentCheckTypeForm} from "./DocumentCheckType";

export const DocumentCheckTypeList = ExpandableList(DocumentCheckType, DocumentCheckTypeForm, REST_DOCUMENT_CHECK_TYPE_URL, "documentCheckType", "Seznam typů dokumentů", "Nový typ dokumentu", "Přidat typ dokumentu");

